import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  TabContainer,
  TabBarWrapper,
  TabWrapper,
  TabContentWrapper
} from "./style";
import queryString from "query-string";
import { TYPE } from "../../constants/filters";
import { TABS_HEIGHT } from "../../constants/fixedStyleVariables";

class Tab extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      active: props.active
    };
  }
  componentWillUnmount() {
    this._isMounted = false;
  }

  async componentDidMount() {
    this._isMounted = true;
    const searchParam = await queryString.parse(this.props.location.search);
    if (searchParam[TYPE] !== undefined) {
      if (this._isMounted) {
        this.setState({ active: searchParam[TYPE] });
      }
    }
    // if (searchParam.tab !== undefined) {
    //   this.setState({ active: searchParam.tab });
    // }
  }

  async componentDidUpdate(prevProps) {
    const prevSearchParam = await queryString.parse(prevProps.location.search);
    const searchParam = await queryString.parse(this.props.location.search);
    if (prevSearchParam[TYPE] !== searchParam[TYPE]) {
      let activeTab = searchParam[TYPE];
      if (searchParam[TYPE] === undefined) {
        activeTab = this.props.active;
      }
      if (this._isMounted) {
        this.setState({ active: activeTab });
      }
    }
  }

  // static getDerivedStateFromProps(props, state) {
  //   let result = {};
  //   if (
  //     props.panes.length !== 0 &&
  //     props.panes.filter(tabs => tabs.active === true).map(tab => tab.id)[0] !==
  //       state.currentTab
  //   ) {
  //     result.active = props.panes
  //       .filter(tabs => tabs.active === true)
  //       .map(tab => tab.id)[0];
  //   }
  //   if (props.active !== state.originActive) {
  //     result.active = props.active;
  //     result.originActive = props.active;
  //   }
  //   return result;
  // }

  render() {
    const { active } = this.state;
    const {
      topMargin,
      title,
      panes,
      setActive,
      expand,
      isInMiddleOfContent
    } = this.props;
    const marginTopIncludingTabsContainer = topMargin + TABS_HEIGHT;

    return (
      <TabContainer>
        <TabBarWrapper
          expand={expand}
          topMargin={topMargin}
          isInMiddleOfContent={isInMiddleOfContent}
        >
          {title && <div className="tab-title">{title}</div>}
          <div className="tabs">
            {panes.map((tabs, key) => {
              let position = "";
              if (key === 0) {
                position = "first";
              } else if (key === panes.length - 1) {
                position = "end";
              }
              return (
                <TabWrapper
                  isInMiddleOfContent={isInMiddleOfContent}
                  position={position}
                  active={parseInt(active) === parseInt(tabs.id)}
                  activeColor={
                    parseInt(active) === parseInt(tabs.id) ? tabs.tabColor : ""
                  }
                  key={key}
                  onClick={() => setActive(tabs.id)}
                >
                  <i className={tabs.tabIcon}> </i>
                  <span className="tab-name no-select">{tabs.tabName}</span>
                </TabWrapper>
              );
            })}
          </div>
        </TabBarWrapper>

        <TabContentWrapper>
          {panes
            .filter(tabs => parseInt(tabs.id) === parseInt(active))
            .map((tab, key) => {
              const searchParam = queryString.parse(document.location.search);
              if (parseInt(tab.id) === parseInt(searchParam[TYPE])) {
                return (
                  <tab.component
                    topMargin={marginTopIncludingTabsContainer}
                    key={key}
                  />
                );
              }
              if (searchParam[TYPE] === undefined) {
                return (
                  <tab.component
                    topMargin={marginTopIncludingTabsContainer}
                    key={key}
                  />
                );
              }
            })}
        </TabContentWrapper>
      </TabContainer>
    );
  }
}

export default withRouter(Tab);
